// documentCreateRegistry.js
//
// Create-menu targets by source document type.
// Create → Y on document X copies header + owned lines onto a new Y.

export const DOCUMENT_TYPE_KEYS = Object.freeze({
  PROPOSAL: 'PROPOSAL',
  INVOICE: 'INVOICE',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
});

/**
 * @typedef {{
 *   targetTypeKey: string,
 *   label: string,
 *   enabled: boolean,
 * }} DocumentCreateTarget
 */

/** @type {Record<string, DocumentCreateTarget[]>} */
const CREATE_TARGETS_BY_SOURCE = Object.freeze({
  [DOCUMENT_TYPE_KEYS.PROPOSAL]: Object.freeze([
    Object.freeze({
      targetTypeKey: DOCUMENT_TYPE_KEYS.INVOICE,
      label: 'Invoice',
      enabled: true,
    }),
    Object.freeze({
      targetTypeKey: DOCUMENT_TYPE_KEYS.PURCHASE_ORDER,
      label: 'Purchase Order',
      enabled: true,
    }),
  ]),
  [DOCUMENT_TYPE_KEYS.INVOICE]: Object.freeze([
    Object.freeze({
      targetTypeKey: DOCUMENT_TYPE_KEYS.INVOICE,
      label: 'Invoice',
      enabled: true,
    }),
    Object.freeze({
      targetTypeKey: DOCUMENT_TYPE_KEYS.PURCHASE_ORDER,
      label: 'Purchase Order',
      enabled: false,
    }),
  ]),
  [DOCUMENT_TYPE_KEYS.PURCHASE_ORDER]: Object.freeze([
    Object.freeze({
      targetTypeKey: DOCUMENT_TYPE_KEYS.INVOICE,
      label: 'Invoice',
      enabled: true,
    }),
  ]),
});

/**
 * @param {unknown} typeKey
 * @returns {string}
 */
export function normalizeDocumentTypeKey(typeKey) {
  return String(typeKey || '').trim().toUpperCase();
}

/**
 * @param {unknown} sourceTypeKey
 * @returns {DocumentCreateTarget[]}
 */
export function getDocumentCreateTargets(sourceTypeKey) {
  const key = normalizeDocumentTypeKey(sourceTypeKey);
  const targets = CREATE_TARGETS_BY_SOURCE[key];
  return Array.isArray(targets) ? targets.map((row) => ({ ...row })) : [];
}

/**
 * @param {unknown} sourceTypeKey
 * @returns {boolean}
 */
export function hasDocumentCreateMenu(sourceTypeKey) {
  return getDocumentCreateTargets(sourceTypeKey).some((row) => row.enabled);
}
